import { createContext, FC, ReactNode, useContext, useState } from 'react';
import { useStore } from 'zustand';

import {
  createReverificationStore,
  ReverificationState,
  ReverificationStoreApi,
} from '../stores/createReverificationStore';

const ReverificationStoreContext = createContext<ReverificationStoreApi | null>(null);

export const ReverificationProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [store] = useState(() => createReverificationStore());
  return (
    <ReverificationStoreContext.Provider value={store}>
      {children}
    </ReverificationStoreContext.Provider>
  );
};

export function useReverificationStore<U>(selector: (s: ReverificationState) => U): U {
  const store = useContext(ReverificationStoreContext);
  if (!store) {
    throw new Error('useReverificationStore must be used within ReverificationProvider');
  }
  return useStore(store, selector);
}
